var _style, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelyProgramUpdates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.8 16",
    style: {
      enableBackground: "new 0 0 14.8 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,8.3L4.2,2.1c0,0,0.1-0.1,0.2-0.1l8,6v0.1C12.4,8.1,12.4,8.2,12.4,8.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,10.2L3.3,3.1c0-0.1,0.1-0.2,0.2-0.2l9.2,6.9C12.7,9.9,12.8,10,12.8,10.2C12.8,10.1,12.8,10.2,12.8,10.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,12.8c0,0.1-0.1,0.2-0.1,0.2L2.7,4.2c0-0.1,0.1-0.2,0.1-0.3L14.7,12.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,13.3h-0.5L2.4,5.5c0-0.1,0-0.2,0-0.3L13.3,13.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.2,13.3 10.7,13.3 2.4,7 2.4,6.7 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,13.3H8.7L2.4,8.6c0-0.1,0-0.2,0-0.3L9.1,13.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,13.3H6.6L2,9.9c0-0.1,0-0.2,0.1-0.3L7,13.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,13.3H4.5l-3-2.3c0-0.1,0.1-0.1,0.1-0.2L5,13.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.9,13.3H2.5l-2.1-1.6c0.1-0.1,0.2-0.1,0.2-0.2L2.9,13.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.8,13.3H0.5c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.2-0.5L0.8,13.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,1.3C9.2,1.3,9.2,1.3,9.2,1.3l1.3,1.1l0.6,0.4V2.6c0,0-0.5-0.5-0.9-0.8C9.8,1.6,9.2,1.3,9.2,1.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,14c0,0.1,0,0.2-0.1,0.2H5.7c0-0.1-0.1-0.2-0.1-0.2H9.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,14.7c-0.1,0.1-0.2,0.2-0.3,0.2H6.3C6.2,14.8,6,14.8,6,14.7H8.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,5.1c0,1-0.8,1.7-1.7,1.7c-0.9,0-1.6-0.7-1.7-1.5L5.3,1.4c0.1,0,0.2-0.1,0.3-0.1L10.5,5 c0-0.4,0.2-0.7,0.4-0.9l-0.5-0.4L6.9,1C7,1,7.1,1,7.2,1l3.3,2.5L11,3.9c0.3-0.3,0.7-0.5,1.2-0.5C13.2,3.4,13.9,4.2,13.9,5.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelyProgramUpdates);
export default __webpack_public_path__ + "static/media/timely-program-updates.60416a64c9530d6484a7bd805822739c.svg";
export { ForwardRef as ReactComponent };